module.exports = __webpack_public_path__ + "img/mhhc_logo.9ca53c76.png";